let windowScrollTop = 0;
let didScroll;
let lastScrollTop = 0;
let delta = 5;
let headerHeight = $('.js-header-sticky').outerHeight();
let headerOffsetTop = 0;

if ($('.js-header-bar').length) {
  headerOffsetTop = $('.js-header-bar').offset().top + $('.js-header-bar').outerHeight();
}

$(window).on('resize orientationchange', function () {
  if ($('.js-header-bar').length) {
    headerOffsetTop = $('.js-header-bar').offset().top + $('.js-header-bar').outerHeight();
  }
});

$(window).on('scroll', function () {
  windowScrollTop = $(window).scrollTop();

  if (windowScrollTop > headerOffsetTop) {
    $('.js-header-sticky').addClass('header--sticky');
  } else {
    $('.js-header-sticky').removeClass('header--sticky header--sticky-show');
  }
});

function hasScrolled() {
  var scrollTop = $(window).scrollTop();

  if (Math.abs(lastScrollTop - scrollTop) <= delta) return;

  if (scrollTop > lastScrollTop && scrollTop > headerOffsetTop) {
    // Scroll Down
    $('.js-header-sticky').removeClass('header--sticky-show');
  } else {
    // Scroll Up
    if (scrollTop + $(window).height() < $(document).height()) {
      $('.js-header-sticky').addClass('header--sticky-show');
    }
  }

  lastScrollTop = scrollTop;
}

// Hide Header on scroll down
$(window).scroll(function (event) {
  didScroll = true;
});

setInterval(function () {
  if (didScroll && windowScrollTop > headerOffsetTop) {
    hasScrolled();
    didScroll = false;
  }
});

$(window).on('load resize orientationchange', function () {
  const $header = $('.js-header-sticky');
  const headerHeight = $header.outerHeight();

  if (!$header.hasClass('header--sticky')) {
    $('.main').css('margin-top', headerHeight);
  }
});
